import Vue from 'vue'
import contextmenu from './contextmenu'
import snapshot from './snapshot'
import map from './map'

const data = {
    namespaced:true,//注意 模块化管理数据请不要忘了命名空间的开启
    state: {
        ...contextmenu.state,
        ...snapshot.state,
        ...map.state,

        editMode: 'edit', // 编辑器模式 edit preview
        componentData: [], // 画布组件数据
        curComponent: null,
        curComponentIndex: null,
        // 点击画布时是否点中组件，主要用于取消选中组件用。
        // 如果没点中组件，并且在画布空白处弹起鼠标，则取消当前组件的选中状态
        isClickComponent: false,
    },
    mutations: {
        ...contextmenu.mutations,
        ...snapshot.mutations,
        ...map.mutations,

        setClickComponentStatus(state, status) {
            state.isClickComponent = status
        },

        setEditMode(state, mode) {
            state.editMode = mode
        },

        // 选中组件
        setCurComponent(state, { component, index }) {
            state.curComponent = component;
            state.curComponentIndex = index;
        },
        // 设置组件的属性
        setCurComponentProperities({ curComponent },properities){
            curComponent.properities=Object.assign(curComponent.properities,properities);
        },
        // 修改组件的样式
        setShapeStyle({ curComponent }, { top, left, width, height, rotate }) {
            if (top) curComponent.style.top = top
            if (left) curComponent.style.left = left
            if (width) curComponent.style.width = width
            if (height) curComponent.style.height = height
            if (rotate) curComponent.style.rotate = rotate
        },
        // 修改组件的单个样式
        setShapeSingleStyle({ curComponent }, { key, value }) {
            curComponent.style[key] = value
        },

        setComponentData(state, componentData = []) {
            Vue.set(state, 'componentData', componentData)
        },
        // 增加组件
        addComponent(state, { component, index }) {
            if (index !== undefined) {
                state.componentData.splice(index, 0, component)
            } else {
                state.componentData.push(component)
            }
        },
        // 删除组件
        deleteComponent(state, index) {
            if (index === undefined) {
                index = state.curComponentIndex
            }
            
            if (index == state.curComponentIndex) {
                state.curComponentIndex = null
                state.curComponent = null
            }
            
            state.componentData.splice(index, 1)
        },
    },
    actions:{
        ...map.actions
    },
    getters:{
        ...map.getters
    }
}

export default data